var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="<div class=\"col-sm-4 remove-left-pad text-left file-upload-directive-style\">\n<span class=\"fileUpload btn btn-primary\">\n<span class=\"upl upload-btn\">{{'shipmentBatch.select_file_btn_label' | translate}}</span>\n<input type=\"file\" class=\"upload up\" multiple=\"multiple\" accept=\".csv,.pdf,.doc,.docx,.xls,.xlsx\"/>\n</span>\n</div>";
var id1="file-upload.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=v1;


//////////////////
// WEBPACK FOOTER
// ./client/app/common/file-upload/file-upload.html
// module id = 2493
// module chunks = 1